import React from "react";

const Stat_Parameters_And_Stat = () => {
  return (
    <div>
      <h1>Stat Parameters & Stat</h1>
    </div>
  );
};

export default Stat_Parameters_And_Stat;
